import { createFileRoute } from '@tanstack/react-router'
import { trpc } from '@/main'
import { useJob } from '@/hooks/use-job'
import { DistributionPending } from './-components/shared/distribution-pending'
import { Distribution } from './-components/shared/distribution'
import { EmptyState } from './-components/shared/empty-state'
import { GroupContextProvider } from './-components/shared/group-context'

export const Route = createFileRoute('/_app/jobs/$jobId/distribution')({
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps, params }) => {
    context.queryClient.prefetchQuery(
      trpc.companies.getJobIntegrantIndicators.queryOptions({ jobId: Number(params.jobId), type: deps.type }),
    )
  },
  component: RouteComponent,
  pendingComponent: DistributionPending,
})

function RouteComponent() {
  const { jobId } = Route.useParams()
  const { jobIntegrants } = useJob(Number(jobId))

  const members = (jobIntegrants?.members ?? []).map((member) => ({
    ...member,
    id: member.id,
  }))

  if (jobIntegrants?.emptyStateCode) {
    return <EmptyState code={jobIntegrants.emptyStateCode} surface="distribution" />
  }

  return (
    <GroupContextProvider type="job">
      <Distribution profiles={members} data={jobIntegrants?.distribution} showFilters />
    </GroupContextProvider>
  )
}
